import React from "react"
import styled from "styled-components"
import Laptop from './images/laptop2'
import Button from './common/Link'
const Container = styled.div`

@media(max-width: 919px) {
      z-index: 1;
  }
  `
const Wrapper = styled.div`
  color: #FFF;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
    width: 850px;
    padding-top: 4rem;
  @media(max-width: 919px) {
    grid-template-columns: 1fr;

  }
  max-width: 100%;
  padding-bottom: 15rem;
  justify-content: center;
  margin: 0 auto;
  @media(min-width: 1240px) {
    grid-gap: 8rem;
  }
` 
const WrapperContent = styled.div`
    max-width: 583px;

  @media(max-width: 919px) {
    max-width: 100%;
  }
`
const Title = styled.h2`
  font-size: 3.5rem;
  margin: 0;
  margin-top: 15px;
  line-height: 4.8rem;
  @media(max-width: 919px) {
    text-align: center;
  }
  br {
    @media(max-width: 919px) {
      display: none;
    }
  }
`
const Description = styled.p`
  font-size: 1rem;
  font-weight: 300;
  line-height: 25px;
  margin-bottom: 30px;
  @media(max-width: 919px) {
    text-align: center;
  }
  & + a {
    @media(min-width: 920px) {
      max-width: 290px;
    }
    
  }
`
const Header = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  @media(max-width: 919px) {
      justify-content: center;
    }
  h3 {
    font-size: 1.25rem;
    margin-top: 15px;
  }
`

const ImgWrapper = styled.div`
  margin-top: -230px;
  display: flex;
  justify-content: center;
`

const Img = styled.div`
  width: 954px;
  max-width: 100%;
`
const Design = ({ handle }) => (
  <Container>
  <section className="container mSection bgPrimaryLight rounded" data-aos='zoom-out' data-aos-duration="600">
              <Wrapper id="design" >
                <div>
                <Title>Design <br />modular & <br />inteligente</Title>
                </div>
                <WrapperContent>
                  <Header>
                  <i className="far fa-layer-group" />
                  <h3>Estrutura de design</h3>
                  </Header>
                  <Description>Baseado em um sistema de cards voltado para a experiência do usuário, a estrutura de design tem seus componentes agrupados em camadas de blocos, nos quais é viável reaproveitá-los via código.</Description>
                  <Button flat target="__blank" link="https://conteudo-mkt.tagplus.com.br/design/tagplus/style_guide/style_guid_tagplus2.0_v2.pdf">Baixe o guia de estilos <i className='fal fa-arrow-to-bottom'></i></Button>
                </WrapperContent>
                </Wrapper>
               
          </section>
          <ImgWrapper data-aos='zoom-out' data-aos-duration="600">
            <Img>
              <Laptop />
            </Img>
          </ImgWrapper>
  </Container>
   
 )
export default Design
